<app-asistencia-menu    *ngIf="renderMenu "    
                        [handlerType]=handlerType
                        (renderComponent) = renderComponent($event)>
</app-asistencia-menu>
<app-asistente-ventana *ngIf="!renderMenu" [renderChat]=renderChat [renderEmail]=renderEmail 
    [renderMenuArbol]=renderMenuArbol [ctx]="ctx" [formElements]=formElements 
    (renderMenuArbolEmitter)="emitRenderMenuArbol($event)" 
    (switchHandlerEmitter)="emitSwitchHandlerEmitter($event)" 
    (changeContextDataEmitter)="emitChangeContextDataEmitter($event)">
    
</app-asistente-ventana>